<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon">
    <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
  </div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Lançar estoque em lote</h2>
    <span class="modal-subtitle">{{ data.ordens.length }} ordem(ns) selecionada(s)</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn" (click)="cancelar()" [disabled]="isSalvando">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  @if (isCarregando) {
  <div class="carregando">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
  } @else {

  @if (ordensExcluidas.length > 0) {
  <app-alert-card type="warning" title="Lançamento individual necessário">
    <ul class="lista-excluidas">
      @for (excluida of ordensExcluidas; track excluida.numero) {
      <li>OP {{ excluida.numero }} · {{ excluida.nomeProduto }} — {{ excluida.motivo }}</li>
      }
    </ul>
  </app-alert-card>
  }

  @if (ordensElegiveis.length === 0) {
  <p class="texto-vazio">Nenhuma ordem elegível para lançamento em lote.</p>
  } @else {

  <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
    <mat-label>Localização de entrada (todos os produtos fabricados)</mat-label>
    <mat-select [(ngModel)]="idLocalizacaoEstoqueEntrada">
      @for (local of localizacoes; track local.id) {
      <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <h3 class="secao-caption">Baixa de matéria-prima consolidada</h3>
  @for (insumo of insumosConsolidados; track insumo.idProduto) {
  <div class="linha-insumo">
    <div class="linha-insumo__produto">
      <strong>{{ insumo.nomeProduto }}</strong>
      <span class="linha-insumo__movimento">
        −{{ insumo.quantidadeTotal | abnt:'quantidade':(insumo.isFracionada ? undefined : 0) }} {{ insumo.unidade }}
      </span>
    </div>
    <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
      <mat-label>Localização de saída</mat-label>
      <mat-select [(ngModel)]="insumo.idLocalizacaoEstoque">
        @for (local of localizacoes; track local.id) {
        <mat-option [value]="local.id">{{ local.descricao }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  }

  <h3 class="secao-caption">Entrada de produtos fabricados ({{ ordensElegiveis.length }})</h3>
  <app-alert-card type="success">
    <div class="tabela-entradas">
      @for (ordem of ordensElegiveis; track ordem.idOrdemProducao) {
      <div class="tabela-entradas__linha">
        <span>OP {{ ordem.numero }} · {{ ordem.nomeProduto }}</span>
        <span class="text-bold">+{{ ordem.quantidade | abnt:'quantidade':(ordem.isUnidadeMedidaFracionada ? undefined : 0) }} {{ ordem.unidade }}</span>
      </div>
      }
    </div>
  </app-alert-card>
  }
  }
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()" [disabled]="isSalvando">Cancelar</button>
  <button mat-flat-button class="btn-primary" [disabled]="!podeConfirmar" (click)="confirmar()">Confirmar lançamento</button>
</mat-dialog-actions>
